import StateInterface from "../state-interface";

export const ai_boost_agent_output_meta_optimization_graph: StateInterface["ai_boost_agent_output_meta_optimization_graph"] = {
	_id: "",
	campaign_id: "",
	boost_id: "",
	summary: "",
	created_at: new Date().toISOString(),
	updated_at: new Date().toISOString(),
	deleted_at: new Date().toISOString(),
	is_deleted: false,
};